import { PracticeProfile, SpecialistProfile } from '../types'

export type GetLinkReviewInfoProps = {
  specialist?: SpecialistProfile
  practice?: PracticeProfile
  locale: string
}

export const getLinkReviewInfo = ({ practice, specialist, locale }: GetLinkReviewInfoProps) => {
  const link = practice ? `/${locale}/practice/${practice?.slug}` : `/${locale}/specialist/${specialist?.slug}`
  const linkReviews = practice
    ? `/${locale}/practice/${practice?.slug}#reviews`
    : `/${locale}/specialist/${specialist?.slug}#reviews`

  return { link, linkReviews }
}
